/**
 * TypingIndicator — replica main.css:.typing (líneas 286-302).
 * 3 dots staggered con animation typingBlink 1.2s infinite linear.
 * Delays 0 / 0.15s / 0.3s definidos en index.css con .typing-dot:nth-child.
 */
export function TypingIndicator() {
  return (
    <div
      className="typing inline-flex items-center gap-1 px-1"
      role="status"
      aria-label="El asistente está escribiendo"
    >
      <span className="typing-dot" />
      <span className="typing-dot" />
      <span className="typing-dot" />
    </div>
  )
}
